/**
 * @generated SignedSource<<39038f465a12739cb8e06d607bd1add2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type AssignmentState = "COMPLETE" | "IN_PROGRESS" | "%future added value";
export type SortEnumType = "ASC" | "DESC" | "%future added value";
export type AssignmentsFilterInput = {
  assignmentState?: AssignmentState | null | undefined;
  classIds?: ReadonlyArray<string> | null | undefined;
  dueOnFrom?: any | null | undefined;
  dueOnTo?: any | null | undefined;
  isActive: ActiveRecords;
  nameContains?: string | null | undefined;
  skillIds?: ReadonlyArray<string> | null | undefined;
  startedOnFrom?: any | null | undefined;
  startedOnTo?: any | null | undefined;
};
export type AssignmentSortInput = {
  createdBy?: UserSortInput | null | undefined;
  createdOn?: SortEnumType | null | undefined;
  dueOn?: SortEnumType | null | undefined;
  id?: SortEnumType | null | undefined;
  isActive?: SortEnumType | null | undefined;
  isObfuscated?: SortEnumType | null | undefined;
  modifiedBy?: UserSortInput | null | undefined;
  modifiedOn?: SortEnumType | null | undefined;
  name?: SortEnumType | null | undefined;
  skill?: SkillSortInput | null | undefined;
  startedOn?: SortEnumType | null | undefined;
};
export type SkillSortInput = {
  assessmentInfo?: SortEnumType | null | undefined;
  code?: SortEnumType | null | undefined;
  context?: SortEnumType | null | undefined;
  createdBy?: UserSortInput | null | undefined;
  createdOn?: SortEnumType | null | undefined;
  difficulty?: SortEnumType | null | undefined;
  essentialQuestion?: SortEnumType | null | undefined;
  id?: SortEnumType | null | undefined;
  isActive?: SortEnumType | null | undefined;
  lessonInfo?: SortEnumType | null | undefined;
  mapCutoffScore?: SortEnumType | null | undefined;
  modifiedBy?: UserSortInput | null | undefined;
  modifiedOn?: SortEnumType | null | undefined;
  name?: SortEnumType | null | undefined;
  progressionNotes?: SortEnumType | null | undefined;
  summary?: SortEnumType | null | undefined;
};
export type UserSortInput = {
  createdBy?: UserSortInput | null | undefined;
  createdOn?: SortEnumType | null | undefined;
  email?: SortEnumType | null | undefined;
  externalSync?: ExternalSyncSortInput | null | undefined;
  externalSyncId?: SortEnumType | null | undefined;
  firstName?: SortEnumType | null | undefined;
  fullName?: SortEnumType | null | undefined;
  id?: SortEnumType | null | undefined;
  isActive?: SortEnumType | null | undefined;
  isMetabaseAccessEnabled?: SortEnumType | null | undefined;
  isMetabaseEmailEnabled?: SortEnumType | null | undefined;
  isObfuscated?: SortEnumType | null | undefined;
  lastName?: SortEnumType | null | undefined;
  lastNameFirst?: SortEnumType | null | undefined;
  modifiedBy?: UserSortInput | null | undefined;
  modifiedOn?: SortEnumType | null | undefined;
  owner?: UserSortInput | null | undefined;
  publicUserId?: SortEnumType | null | undefined;
};
export type ExternalSyncSortInput = {
  id?: SortEnumType | null | undefined;
  isObfuscated?: SortEnumType | null | undefined;
  lastUpdatedOn?: SortEnumType | null | undefined;
  source?: SortEnumType | null | undefined;
};
export type AssignmentGetAssignmentStudentDashboardQuery$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  filter: AssignmentsFilterInput;
  first?: number | null | undefined;
  last?: number | null | undefined;
  order?: ReadonlyArray<AssignmentSortInput> | null | undefined;
  skip?: boolean | null | undefined;
};
export type AssignmentGetAssignmentStudentDashboardQuery$data = {
  readonly assignments?: {
    readonly nodes: ReadonlyArray<{
      readonly classes: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly createdBy: {
        readonly firstName: string | null | undefined;
        readonly id: string;
        readonly lastName: string | null | undefined;
      } | null | undefined;
      readonly dueOn: any;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly skill: {
        readonly code: string | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly startedOn: any;
      readonly studentSkillAssignments: ReadonlyArray<{
        readonly id: string;
        readonly submittedOn: any | null | undefined;
      } | null | undefined> | null | undefined;
    }> | null | undefined;
    readonly totalCount: number;
  } | null | undefined;
};
export type AssignmentGetAssignmentStudentDashboardQuery = {
  response: AssignmentGetAssignmentStudentDashboardQuery$data;
  variables: AssignmentGetAssignmentStudentDashboardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skip"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
          },
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          },
          {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
          },
          {
            "kind": "Variable",
            "name": "order",
            "variableName": "order"
          }
        ],
        "concreteType": "AssignmentNodeConnection",
        "kind": "LinkedField",
        "name": "assignments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AssignmentNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dueOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startedOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillNode",
                "kind": "LinkedField",
                "name": "skill",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ClassNode",
                "kind": "LinkedField",
                "name": "classes",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "isActive": "ACTIVE"
                    }
                  }
                ],
                "concreteType": "StudentSkillAssignmentNode",
                "kind": "LinkedField",
                "name": "studentSkillAssignments",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "submittedOn",
                    "storageKey": null
                  }
                ],
                "storageKey": "studentSkillAssignments(filter:{\"isActive\":\"ACTIVE\"})"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentGetAssignmentStudentDashboardQuery",
    "selections": (v9/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssignmentGetAssignmentStudentDashboardQuery",
    "selections": (v9/*: any*/)
  },
  "params": {
    "cacheID": "556f3533d90d891ef15590233a918700",
    "id": null,
    "metadata": {},
    "name": "AssignmentGetAssignmentStudentDashboardQuery",
    "operationKind": "query",
    "text": "query AssignmentGetAssignmentStudentDashboardQuery(\n  $filter: AssignmentsFilterInput!\n  $first: Int\n  $after: String\n  $last: Int\n  $before: String\n  $order: [AssignmentSortInput!]\n  $skip: Boolean = false\n) {\n  assignments(filter: $filter, first: $first, last: $last, after: $after, before: $before, order: $order) @skip(if: $skip) {\n    nodes {\n      id\n      name\n      dueOn\n      startedOn\n      createdBy {\n        firstName\n        lastName\n        id\n      }\n      skill {\n        id\n        name\n        code\n      }\n      classes {\n        id\n        name\n      }\n      studentSkillAssignments(filter: {isActive: ACTIVE}) {\n        id\n        submittedOn\n      }\n    }\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ec1afb83607c88b37855730ff85b470";

export default node;
